import * as React from "react"
import {FooterScreen,Header} from "../shared";

export const HomeScreen=() => {

    React.useEffect(() => {
        // @ts-ignore
        $(".player").mb_YTPlayer();
        //@ts-ignore
        $(".player").YTPPlay();
    },[])

    return (
        <>
            <div className="search-section">
                <a className="close-search" href="#"></a>
                <div className="d-flex justify-content-center align-items-center h-100">
                    <form method="post" action="#" className="w-50">
                        <div className="row">
                            <div className="col-10">
                                <input type="search" value="" className="form-control palce bg-transparent border-0 search-input" placeholder="Search Here ..." />
                            </div>
                            <div className="col-2 mt-3">
                                <button type="submit" className="btn bg-transparent text-white"> <i className="fas fa-search"></i> </button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>

            <div id="ju-loading-screen">
                <div className="sk-double-bounce">
                    <div className="sk-child sk-double-bounce1"></div>
                    <div className="sk-child sk-double-bounce2"></div>
                </div>
            </div>

            <Header />
            <section className="content-section video-section fables-after-overlay">
                <div className="pattern-overlay">
                    <a id="bgndVideo" className="player" data-property="{videoURL:'https://www.youtube.com/watch?v=205-gOtmlR4',containment:'.video-section', quality:'large', mute: 'true' ,autoPlay:true, opacity:1}">bg</a>
                    <div className="container position-relative z-index">
                        <div className="fables-video-caption text-center wow zoomIn" data-wow-delay="1s" data-wow-duration="2s">
                            <h1 className="white-color font-weight-bold mt-6" style={{fontSize: '2.5rem'}}>Structured Growth for Regulated Industries</h1>
                            <p className="fables-fifth-text-color mt-3 mb-4" style={{fontSize: '1.3rem'}}>
                                Kovio partners with investors and leadership teams to institutionalize execution across regulatory readiness, commercial scale, and applied AI.
                            </p>
                            <p className="fables-fifth-text-color mt-2 mb-4" style={{fontSize: '1.1rem', fontStyle: 'italic'}}>
                                Growth without structure creates risk. Structure enables durable growth.
                            </p>
                            <a data-fancybox href="https://www.youtube.com/watch?v=205-gOtmlR4">
                                <span className="fables-iconplay fables-second-text-color fa-4x wow bounce"></span>
                            </a>

                        </div>
                    </div>
                </div>
            </section>

            <div className="container">
                <div className="row my-4 my-md-5 align-items-center">
                    <div className="col-12 text-center mb-3">
                        <h3 className="font-28 font-weight-bold fables-second-text-color">Built for Investors and Growth-Stage Leaders</h3>
                    </div>
                    <div className="col-12 col-md-10 offset-md-1">
                        <p className="fables-forth-text-color text-center mb-4">Kovio works with:</p>
                        <ul className="fables-forth-text-color" style={{listStyleType: 'disc', paddingLeft: '20px'}}>
                            <li className="mb-2">Venture and growth investors seeking operational leverage</li>
                            <li className="mb-2">Leadership teams scaling in regulated industries</li>
                            <li className="mb-2">Organizations preparing for accelerated commercial expansion</li>
                        </ul>
                        <p className="fables-forth-text-color text-center mt-4 font-weight-bold">We align growth with institutional discipline.</p>
                    </div>
                </div>

                <div className="row my-5">
                    <div className="col-12 text-center mb-3">
                        <h3 className="font-28 font-weight-bold fables-second-text-color">Our Three Growth Pillars</h3>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="p-4 text-center border rounded h-100">
                            <h4 className="font-18 semi-font">Regulatory & Quality Execution</h4>
                            <p className="fables-forth-text-color">Scaling compliance infrastructure in parallel with growth.</p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 mt-3 mt-md-0">
                        <div className="p-4 text-center border rounded h-100">
                            <h4 className="font-18 semi-font">Revenue & Commercial Acceleration</h4>
                            <p className="fables-forth-text-color">Designing revenue architecture, commercial teams, and measurable execution.</p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 mt-3 mt-md-0">
                        <div className="p-4 text-center border rounded h-100">
                            <h4 className="font-18 semi-font">Applied AI Strategy & Governance</h4>
                            <p className="fables-forth-text-color">Deploying AI for leverage while maintaining operational and regulatory integrity.</p>
                        </div>
                    </div>
                </div>

                <div className="row my-5">
                    <div className="col-12 col-md-10 offset-md-1">
                        <h3 className="font-28 font-weight-bold fables-second-text-color text-center mb-4">Our Approach</h3>
                        <h4 className="font-22 semi-font mb-3">Structured Execution Architecture</h4>
                        <p className="fables-forth-text-color mb-3">We embed within leadership teams to:</p>
                        <ul className="fables-forth-text-color mb-4" style={{listStyleType: 'disc', paddingLeft: '20px'}}>
                            <li className="mb-2">Align growth strategy with execution capacity</li>
                            <li className="mb-2">Reduce operational friction</li>
                            <li className="mb-2">Institutionalize accountability</li>
                            <li className="mb-2">Create durable operating models</li>
                        </ul>
                        <p className="fables-forth-text-color font-weight-bold mb-2">We are not consultants delivering slides.</p>
                        <p className="fables-forth-text-color font-weight-bold">We are execution partners delivering structure.</p>
                    </div>
                </div>

                <div className="row my-5">
                    <div className="col-12 col-md-10 offset-md-1">
                        <h3 className="font-28 font-weight-bold fables-second-text-color text-center mb-4">Why It Matters</h3>
                        <p className="fables-forth-text-color mb-3">In regulated sectors such as pharma, medical devices, and healthcare:</p>
                        <ul className="fables-forth-text-color mb-4" style={{listStyleType: 'disc', paddingLeft: '20px'}}>
                            <li className="mb-2">Growth amplifies risk</li>
                            <li className="mb-2">AI amplifies complexity</li>
                            <li className="mb-2">Revenue amplifies regulatory scrutiny</li>
                        </ul>
                        <p className="fables-forth-text-color mb-2">Without execution discipline, expansion becomes fragile.</p>
                        <p className="fables-forth-text-color font-weight-bold">Kovio ensures growth remains investable.</p>
                    </div>
                </div>

                <div className="row my-5">
                    <div className="col-12 text-center">
                        <h3 className="font-28 font-weight-bold fables-second-text-color">Strategic Advisors</h3>
                        <p className="fables-forth-text-color mb-3">Kovio collaborates with experienced leaders across regulatory, commercial, and enterprise domains to refine scalable growth architecture.</p>
                        <p className="fables-forth-text-color mb-2">Advisors contribute to:</p>
                        <ul className="fables-forth-text-color" style={{listStyleType: 'disc', paddingLeft: '20px', display: 'inline-block', textAlign: 'left'}}>
                            <li className="mb-2">Regulatory interpretation & modernization</li>
                            <li className="mb-2">Commercial scaling frameworks</li>
                            <li className="mb-2">AI governance models</li>
                            <li className="mb-2">Institutional operating discipline</li>
                        </ul>
                    </div>
                </div>
            </div>
            <FooterScreen />
        </>
    )
}